import { render, staticRenderFns } from "./grouping-question-component.vue?vue&type=template&id=5e51a740&scoped=true&"
import script from "./grouping-question-component.vue?vue&type=script&lang=ts&"
export * from "./grouping-question-component.vue?vue&type=script&lang=ts&"
import style0 from "./grouping-question-component.vue?vue&type=style&index=0&id=5e51a740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e51a740",
  null
  
)

export default component.exports